import { useEffect, useRef, useState } from "react";
import { Control, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import "./WeighbridgeInput.scss";
import { RequestType } from "../../models/Request";
import { Button } from "primereact/button";
import { t } from "i18next";
import { Weighbridge } from "../../weight-bridge/Weighbridge";
import {useApplicationContext} from "../../application/ApplicationContext";

export interface WeighbridgeInputProps {
    id: string;
    type?: string;
    value: string | number;
    onValueChange: (property: string, value: string) => void;
    labelText: string;
    icon: string;
    iconAlign: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    readOnly?: boolean;
    disabled?: boolean;
    onKeyPress?: (e: any) => void;
    colorType?: string;
    weighbridge?: Weighbridge;
    serialPortValue?: string;
}

export const WeighbridgeInput = (p: WeighbridgeInputProps) => {
    const {
        id,
        type,
        value,
        onValueChange,
        labelText,
        icon,
        iconAlign,
        control,
        setValue,
        errors,
        rules,
        readOnly,
        disabled,
        onKeyPress,
        colorType,
        weighbridge,
    } = p;

    const {
        state
    } = useApplicationContext();

    const [isCaptured, setIsCaptured] = useState<boolean>(false);
    const [placeholderText, setPlaceholderText] = useState<string>();

    useEffect(() => {
        if (!weighbridge || !state.serialPortValue) return;
        const parsedData = weighbridge.parse(state.serialPortValue);
        setPlaceholderText((parsedData?.weight ?? 0).toString());
    }, [state.serialPortValue]);
    
    useEffect(() => {
        if (setValue) setValue(labelText, value);
    }, [value]);

    const capture = () => {
        if (!weighbridge || !state.serialPortValue) return;
        setIsCaptured(true);
        const parsedData = weighbridge.parse(state.serialPortValue);
        onValueChange(id, (parsedData?.weight ?? 0).toString());
    };
    
    return (
        <div className="weighbridge-input-wrapper">
            <label
                className={classNames("text-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <div className={ iconAlign === 'left' ? "p-input-icon-left" : "p-input-icon-right" }>
                <Controller
                    name={labelText}
                    control={control}
                    rules={rules}
                    render={({ field, fieldState }) => (
                        <div className="weighbridge-input">
                            <div className="input-icon-wrapper">
                                <InputText
                                    {...field}
                                    id={id}
                                    type={type}
                                    value={value}
                                    onChange={(e)=>{
                                        field.onChange(e);
                                        onValueChange(id, e.target.value)}}
                                    className={classNames(
                                        'text-input-field',
                                        { 'text-input-field-request-import': colorType === RequestType.Import },
                                        { 'text-input-field-request-export': colorType === RequestType.Export },
                                        { 'text-input-field-request-relocation': colorType === RequestType.Relocation },
                                        { 'p-invalid': fieldState.invalid }
                                    )}
                                    placeholder={placeholderText}
                                    //readOnly={readOnly || isCaptured || !!weighbridge}
                                    //disabled={disabled || isCaptured || !!weighbridge}
                                    onKeyPress={onKeyPress}
                                />
                                <span className="textinput-icon-wrapper">
                                    <i className={icon + " textinput-icon"} />
                                </span>
                            </div>
                            {weighbridge && <Button onClick={capture} disabled={isCaptured}>{t('Preuzmi sa vage')}</Button>}
                        </div>
                    )}
                />
            </div>
        </div>
    );
};
